<app-spremiste-zaglavlje
  [parentArchiveName]="parentArchiveName"
  [parentObjectName]="parentObjectName"
  [parentProstorijaName]="prostorijaName"
  [parentObjectAdress]="parentObjectAdress"
  [parentObjectArea]="parentObjectArea"
/>

<ntap-prime-common-itemview #itemView></ntap-prime-common-itemview>
